export type ProjectStage =
  | "planning"
  | "procurement"
  | "fabrication"
  | "delivery"
  | "installation"
  | "inspection"
  | "complete"

export const PROJECT_STAGES: { id: ProjectStage; label: string; opacity: number }[] = [
  { id: "planning",     label: "Planning",     opacity: 0.25 },
  { id: "procurement",  label: "Procurement",  opacity: 0.38 },
  { id: "fabrication",  label: "Fabrication",  opacity: 0.5  },
  { id: "delivery",     label: "Delivery",     opacity: 0.62 },
  { id: "installation", label: "Installation", opacity: 0.78 },
  { id: "inspection",   label: "Inspection",   opacity: 0.9  },
  { id: "complete",     label: "Complete",     opacity: 1    },
]

export function stageLabel(stage: string): string {
  return PROJECT_STAGES.find((s) => s.id === stage)?.label ?? stage
}

export function stageOpacity(stage: string): number {
  return PROJECT_STAGES.find((s) => s.id === stage)?.opacity ?? 0.4
}
